export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-map-34b9166062ba56c6ff5007ade5464890.svg";